export var getDate = function getDate(_ref) {
  var year = _ref.year,
    month = _ref.month,
    day = _ref.day;
  var date = new Date();
  date.setFullYear(year);
  date.setMonth(month - 1);
  date.setDate(day);
  return date;
};